import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Section from 'dashboard/layouts/FormLayout/Section';
import { Organization } from 'dashboard/models/organization';
import Button from 'design-system/components/Button';
import { isRequired, Rule, withMessage } from 'lib/utils/formValidation';

const validate: Record<keyof FormOrganizationSessionLengthData, Rule[]> = {
  'session-length-seconds': [withMessage('Please enter a number', isRequired)],
};

const FormOrganizationSessionLength = ({
  handleSubmit,
  submitting,
  pristine,
}: InjectedFormProps) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Section cols={2} colsMobile={1}>
        <Field
          component={InputField}
          name='session-length-seconds'
          id='session-length-seconds'
          type='number'
          data-test='form-organization-session-length__organization-session-length'
          disabled={submitting}
          validate={validate['session-length-seconds']}
          placeholder='604800'
          label='Session Length (seconds)'
        />
      </Section>

      <Section cols={3} colsMobile={1}>
        <Button
          type='submit'
          data-test='form-organization-session-length__save'
          disabled={submitting || pristine}
          isPending={submitting}
        >
          Save changes
        </Button>
      </Section>
    </Form>
  );
};

export type FormOrganizationSessionLengthData = Pick<
  Organization['attributes'],
  'session-length-seconds'
>;

export const FORM_ORGANIZATION_SESSION_LENGTH_NAME = 'formOrganizationSessionLength';

export default reduxForm<FormOrganizationSessionLengthData, {}>({
  form: FORM_ORGANIZATION_SESSION_LENGTH_NAME,
  enableReinitialize: true,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormOrganizationSessionLength);
